module.exports = __webpack_public_path__ + "h5/img/jckxkz@2x.c9f8cee4.png";